import React from 'react';
import { useRequisition } from '../../../../../../hooks/shared/requisition/useRequisition';

const ExecutiveCount = () => {
  const { executiveRequisitions } = useRequisition();
  return <div style={{ color: 'red' }}>{executiveRequisitions.length}</div>;
};

export default ExecutiveCount;
